import { MainTitle } from "../Components/MainTitle";
import { Question } from "../Components/Question";
import { QuestionWrapper } from "../Components/QuestionWrapper";
import { Cells } from "./Cells";
import React, { useCallback, useEffect } from "react";
import styles from "./QuestionMultiDropdown.module.scss";
import { Footer } from "../Components/Footer";
import { TotalAttempts } from "../Components/TotalAttempts";
import { SubmitButton } from "../Components/SubmitButton";
import { RichText } from "@learningblocks/shared-components";

import { useSelector, useDispatch } from "react-redux";
import {
  selectOption,
  submitQuiz,
  initialiseQuiz,
} from "./QuestionMultiDropdownReduxSlice";
import { CellInfo } from "./QuestionMultiDropdownReduxSlice";
import { FooterFeedback } from "./FooterFeedback";

interface QuestionMultiDropdownProps {
  submitDisabled: unknown;
  totalAttempts: number;
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  titleRows: any;
  hintIndex: number;
  title: string;
  question: string;
  data: CellInfo[];
  showHint: boolean;
  hints: string[];
  figureCaption?: string;
}

const TYPE_OBJECT = "object";

export function QuestionMultiDropdown(props: QuestionMultiDropdownProps) {
  const dispatch = useDispatch();

  const { cells, submitted, globalFeedback, allCorrect, initialised } =
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    useSelector((state: any) => state.msdq);

  const initialisation = useCallback(
    (data: CellInfo[]) => {
      dispatch(initialiseQuiz(data));
    },
    [dispatch]
  );

  const handleOptionChange = useCallback(
    (cellId: string, optionId: string) => {
      dispatch(selectOption({ cellId, optionId }));
    },
    [dispatch]
  );

  // For submitting answers
  const handleSubmit = useCallback(() => {
    dispatch(submitQuiz());
  }, [dispatch]);

  const onSubmit = () => {
    handleSubmit();
  };

  useEffect(() => {
    if (!initialised) {
      initialisation(props.data);
    }
  }, []);

  const caption: { text?: string } =
    props.figureCaption && typeof props.figureCaption === TYPE_OBJECT
      ? (props.figureCaption as { text?: string })
      : { text: props.figureCaption };

  return (
    <div>
      <QuestionWrapper className={styles.questionTable}>
        <div className={styles.questionWrapper}>
          <MainTitle className="questionTable__mainTitle" title={props.title} />
          <Question text={props.question} />
          <Cells data={cells} onOptionSelected={handleOptionChange} />
          <FooterFeedback
            display={submitted}
            feedback={globalFeedback}
            correct={allCorrect}
          />

          <Footer className="questionTable__footer">
            <TotalAttempts
              totalAttempts={props.totalAttempts}
              className="questionTable__footer__totalAttempts"
            />
            <SubmitButton
              disabled={submitted}
              onSubmit={onSubmit}
              label={"Submit answer"}
            />
          </Footer>
        </div>
        {props.figureCaption ? (
          <figcaption className={styles.figcaption}>
            <RichText {...caption} />
          </figcaption>
        ) : null}
      </QuestionWrapper>
    </div>
  );
}
